import script from "./LocalLinares.vue?vue&type=script&setup=true&lang=js"
export * from "./LocalLinares.vue?vue&type=script&setup=true&lang=js"

import "./LocalLinares.vue?vue&type=style&index=0&id=01113a18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01113a18"]])

export default __exports__